"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenQuestion = void 0;
const utils_1 = require("../../../utils");
const lodash_1 = require("lodash");
const assignment_1 = require("../../assignment");
// Content
var OpenQuestion;
(function (OpenQuestion) {
    OpenQuestion.type = 'openQuestion';
    // eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
    class LessonContent {
        static fromAssignmentContent(pinId, content, meta) {
            const custom = (0, lodash_1.cloneDeep)(content);
            const correctAnswer = assignment_1.AssignmentMeta.correctAnswerForPin(meta, pinId);
            return {
                ...custom,
                studentImage: this.studentImageFromMaximumImageUploads(content),
                answer: correctAnswer ? correctAnswer[0] : undefined,
                checkAnswer: custom.hasAnswer,
            };
        }
        static maximumImageUploads(content) {
            if (content.studentImage == 'may') {
                return 1;
            }
            else if (content.studentImage == 'may5') {
                return 5;
            }
            return 0;
        }
        static studentImageFromMaximumImageUploads(content) {
            return (content.maximumNumberOfUploads ? `may${content.maximumNumberOfUploads}` : undefined);
        }
    }
    OpenQuestion.LessonContent = LessonContent;
})(OpenQuestion || (exports.OpenQuestion = OpenQuestion = {}));
// Answer
(function (OpenQuestion) {
    let Answer;
    (function (Answer) {
        Answer.maxLength = 5000;
        function texts(answer) {
            return (answer && answer.texts) || [];
        }
        Answer.texts = texts;
        function isCorrectAnswer(answer) {
            return !!Array.isArray(answer) && !answer.find((a) => typeof a !== 'string');
        }
        Answer.isCorrectAnswer = isCorrectAnswer;
        function numberOfAnswers(answer) {
            return (answer && answer.texts && answer.texts.length) || 0;
        }
        Answer.numberOfAnswers = numberOfAnswers;
        function latestText(answer) {
            return (0, lodash_1.last)(answer && answer.texts);
        }
        Answer.latestText = latestText;
        function attachments(answer) {
            return (answer && answer.attachments) || [];
        }
        Answer.attachments = attachments;
        function isAtAttachmentLimit(answer, content) {
            return attachments(answer).length >= content.maximumNumberOfUploads;
        }
        Answer.isAtAttachmentLimit = isAtAttachmentLimit;
        function update(current, fields) {
            return Object.assign({}, current, fields);
        }
        Answer.update = update;
        function create(fields) {
            return Object.assign({ modifiedAt: Date.now() }, fields);
        }
        Answer.create = create;
        function isDone(answer) {
            if (!answer || ((0, lodash_1.isEmpty)(answer.texts) && (0, lodash_1.isEmpty)(answer.attachments))) {
                return false;
            }
            return true;
        }
        Answer.isDone = isDone;
        function correctAnswerProvided(assignmentContent) {
            return assignmentContent.checkAnswer && !!assignmentContent.hasAnswer;
        }
        Answer.correctAnswerProvided = correctAnswerProvided;
        function explanationProvided(assignmentContent) {
            return !!assignmentContent.explanation;
        }
        Answer.explanationProvided = explanationProvided;
        function getAnswers(assignmentMeta, pinId) {
            return assignment_1.AssignmentMeta.correctAnswerForPin(assignmentMeta, pinId);
        }
        Answer.getAnswers = getAnswers;
        function getAnswerBeforeHint(answer) {
            if (answer.firstTimeOpenHint && answer.texts) {
                return answer.texts[answer.firstTimeOpenHint];
            }
            return undefined;
        }
        Answer.getAnswerBeforeHint = getAnswerBeforeHint;
        function getAnswerifHasTextsOrAttachment(pinEntry) {
            const answer = pinEntry && pinEntry.answer;
            if (!answer || ((0, lodash_1.isEmpty)(answer.texts) && (0, lodash_1.isEmpty)(answer.attachments))) {
                return undefined;
            }
            return {
                ...answer,
                texts: answer.texts || [],
                attachments: answer.attachments || [],
            };
        }
        Answer.getAnswerifHasTextsOrAttachment = getAnswerifHasTextsOrAttachment;
        function rankingPointsForResult(result) {
            if (result && result.type === 'correct')
                return 1;
            return 0;
        }
        Answer.rankingPointsForResult = rankingPointsForResult;
        function testPointsForResults(maxPoints, result) {
            if (result && result.type === 'correct')
                return maxPoints;
            return undefined;
        }
        Answer.testPointsForResults = testPointsForResults;
        function isStringCorrect(text, correctAnswer, settings) {
            const options = { asLowercase: !settings.caseSensitive, normalizeDiacritics: !settings.diacriticSensitive };
            return (0, lodash_1.some)(correctAnswer, (answer) => (0, utils_1.parseStringWithOptions)(text, options) === (0, utils_1.parseStringWithOptions)(answer, options));
        }
        Answer.isStringCorrect = isStringCorrect;
        function resultForAnswer(current, pin, correctAnswer, type) {
            const latest = latestText(current);
            if (!current || !current.texts || (0, lodash_1.isNil)(latest) || (0, lodash_1.isEmpty)(latest)) {
                return { type: 'noAnswer' };
            }
            return {
                type: isStringCorrect(latest, correctAnswer, pin.settings) ? 'correct' : 'incorrect',
            };
        }
        Answer.resultForAnswer = resultForAnswer;
    })(Answer = OpenQuestion.Answer || (OpenQuestion.Answer = {}));
})(OpenQuestion || (exports.OpenQuestion = OpenQuestion = {}));
//# sourceMappingURL=OpenQuestion.js.map